import React, { useState } from 'react'
import './index.scss'
import moment from 'moment'
// import { withStyles } from '@material-ui/core/styles'
// import Slider from '@material-ui/core/Slider'
import { withStyles } from '@mui/styles';
import Slider from '@mui/material/Slider';
import ParticleOverlay from '../particle-overlay'
import { userHasPro } from '../../../../../lib/util'

const HourSlider = withStyles((theme) => ({
  root: {
    width: '90%',
    left: '5%'
  },
  thumb: {
    width: 40,
    height: 20,
    marginLeft: -20,
    backgroundColor: '#589500',
    borderRadius: 3,
    padding: 3,
    boxSizing: 'border-box',
    fontSize: 12,
    fontWeight: 'bold'
  },
  track: {
    height: 12
  },
  rail: {
    height: 12
  },
  mark: {
    height: 6,
    backgroundColor: 'black'
  }
}))(Slider)

const DisplayHourly = (props) => {
  const { forcast, toggleProModal, modalVisible, ideal, position, user } = props,
    [tPlus, setTPlus] = useState(0),
    changeHour = (e, v) => {
      e.preventDefault()
      if (!userHasPro(user)) {
        if (!modalVisible) {
          return toggleProModal()
        }
        return
      }
      if (forcast.length === 0) {
        return
      }
      setTPlus(v)
    },
    getCompassDirection = (deg) => {
      if (deg <= 22.5) {
        return 'N'
      }
      else if (Math.abs(45 - deg) < 22.5) {
        return 'NE'
      }
      else if (Math.abs(90 - deg) <= 22.5) {
        return 'E'
      }
      else if (Math.abs(135 - deg) < 22.5) {
        return 'SE'
      }
      else if (Math.abs(180 - deg) <= 22.5) {
        return 'S'
      }
      else if (Math.abs(225 - deg) < 22.5) {
        return 'SW'
      }
      else if (Math.abs(270 - deg) <= 22.5) {
        return 'W'
      }
      else if (Math.abs(315 - deg) < 22.5) {
        return 'NW'
      } else {
        return 'N'
      }
    },
    entry = forcast !== null ? forcast[tPlus] : {},
    thumbDate = tPlus === 0 ? 'Now' :
      entry && entry.timeStamp ? new moment.utc(entry.timeStamp).local().format('h a') : '',
    labelDate = entry && entry.timeStamp ? new moment.utc(entry.timeStamp).local().format('MM/DD') : ''

  return (
    <div className='hunt-wind-hourly-container'>
      <div className='hunt-wind-hourly-data-block' >
        <div>
          <div className='vertical-center' style={{ width: '60px' }}>
            <p className='hunt-wind-hourly-data-title'>GUST</p>
            <p className='hunt-wind-hourly-data-text'>
              {entry && entry.gust ? `${entry.gust} mph` : '--'}
            </p>
          </div>
        </div>
        <div className='hunt-wind-hourly-dir'>
          <p className='hunt-wind-hourly-compass-text'>
            {entry && entry.direction ? getCompassDirection(entry.direction) : '--'}
          </p>
          <p className='hunt-wind-hourly-data-text'>
            {entry && entry.speed ? `${entry.speed} mph` : '--'}
          </p>
        </div>
        <div>
          <div className='vertical-center' style={{ width: '60px' }}>
            <p className='hunt-wind-hourly-data-title'>CHILL</p>
            <p className='hunt-wind-hourly-data-text'>
              {entry && entry.feelsLikeTemp ? `${entry.feelsLikeTemp}° F` : '--'}
            </p>
          </div>
        </div>
      </div>
      <div>
        <HourSlider
          min={0}
          max={23}
          step={1}
          defaultValue={0}
          value={tPlus}
          marks
          ThumbComponent={(props) => {
            return (
              <span {...props}>
                {thumbDate}
                <span className='hunt-wind-hourly-thumb-label'>
                  {labelDate}
                </span>
              </span>
            )
          }}
          onChange={changeHour} />
      </div>
      {forcast && entry ? <ParticleOverlay position={position} speed={entry.speed} direction={entry.direction} />
        : null}
    </div>
  )
}

export default DisplayHourly